// File: src/pages/candidate/PaymentSuccess.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PaymentSuccess() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-green-50">
            <div className="bg-white p-10 rounded-2xl shadow-xl text-center">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="material-symbols-outlined text-4xl text-green-600">check_circle</span>
                </div>
                <h1 className="text-2xl font-bold text-gray-800">Thanh toán thành công!</h1>
                <p className="text-gray-600 mt-2">Tài khoản của bạn đang được nâng cấp...</p>
                <p className="text-sm text-gray-400 mt-1">Vui lòng đợi trong giây lát.</p>
                
                <button 
                    onClick={() => navigate('/candidate/profile')}
                    className="mt-6 px-6 py-2 bg-green-600 text-white rounded-lg font-bold hover:bg-green-700 transition-all"
                >
                    Quay về Hồ sơ
                </button>
            </div>
        </div>
    );
}